import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
// import toaster from 'utils/toaster';

const deleteEmployees = (userId: number) => {
  const newEndpoints = endpoints.employee.employeeById.replace('{id}', '' + userId);
  return http().delete(newEndpoints);
};

export function useDeleteEmployees() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteEmployees,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchTabItemCountByModule', 'user'] });
      }
    },
  });
}
